/* CDC · Fiche « motif » (05/10/2026) — script du gabarit product.motif (section cdc-fiche-motif).
   Sans dépendance. Choix des options, prix, galerie par variante, guide des tailles, ajout au panier (tiroir du thème), barre mobile.
   Sans JavaScript, la fiche reste achetable par le menu <noscript> de la section. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.cdcMotifReady === '1') return;
    var sectionId = root.dataset.sectionId;
    var dataEl = document.querySelector('script[data-cdc-motif-data="' + sectionId + '"]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    root.dataset.cdcMotifReady = '1';

    var form = root.querySelector('[data-form]');
    var idInput = root.querySelector('[data-variant-id]');
    var cta = root.querySelector('[data-cta]');
    var ctaLabel = root.querySelector('[data-cta-label]');
    var message = root.querySelector('[data-message]');
    var priceEl = root.querySelector('[data-price]');
    var priceFrom = root.querySelector('[data-price-from]');
    var qty = root.querySelector('[data-qty]');
    var bar = root.querySelector('[data-bar]');
    var barPrice = root.querySelector('[data-bar-price]');
    var barLabel = root.querySelector('[data-bar-label]');
    var barCta = root.querySelector('[data-bar-cta]');
    var options = Array.prototype.slice.call(root.querySelectorAll('[data-option]'));
    var variants = data.variantes || [];
    var current = null;
    var busy = false;

    if (idInput) idInput.disabled = false;

    function selected() {
      return options.map(function (fs) {
        var input = fs.querySelector('[data-option-input]:checked');
        return input ? input.value : null;
      });
    }
    function matches(variant, choice, ignoreIndex) {
      for (var i = 0; i < choice.length; i++) {
        if (i === ignoreIndex || choice[i] === null) continue;
        if (variant.options[i] !== choice[i]) return false;
      }
      return true;
    }
    function kindIndex(kind) {
      for (var i = 0; i < options.length; i++) if (options[i].dataset.optionKind === kind) return i;
      return -1;
    }

    /* ——— Galerie ——— */
    var track = root.querySelector('[data-track]');
    var nav = root.querySelector('[data-gallery-nav]');
    var count = root.querySelector('[data-count]');
    var thumbs = root.querySelector('[data-thumbs]');
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    function slides() { return Array.prototype.slice.call(track.querySelectorAll('[data-slide]:not([hidden])')); }
    function slideIndex() {
      var list = slides();
      if (!list.length) return 0;
      var best = 0, bestDistance = Infinity;
      list.forEach(function (slide, i) {
        var distance = Math.abs(slide.offsetLeft - track.offsetLeft - track.scrollLeft);
        if (distance < bestDistance) { bestDistance = distance; best = i; }
      });
      return best;
    }
    function goTo(i, instant) {
      var list = slides();
      if (!list.length) return;
      var index = Math.max(0, Math.min(list.length - 1, i));
      track.scrollTo({ left: list[index].offsetLeft - track.offsetLeft, behavior: instant ? 'auto' : 'smooth' });
    }
    function refreshNav() {
      var list = slides();
      var index = slideIndex();
      if (nav) nav.hidden = list.length < 2;
      if (count) count.textContent = (index + 1) + ' / ' + list.length;
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index >= list.length - 1;
      if (thumbs) Array.prototype.forEach.call(thumbs.children, function (button, i) { button.setAttribute('aria-current', i === index ? 'true' : 'false'); });
    }
    function buildThumbs() {
      if (!thumbs) return;
      var list = slides();
      thumbs.textContent = '';
      thumbs.hidden = list.length < 2;
      list.forEach(function (slide, i) {
        var img = slide.querySelector('img');
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'cdc-motif__thumb';
        button.setAttribute('aria-label', 'Photo ' + (i + 1) + ' sur ' + list.length);
        var small = document.createElement('img');
        small.src = (img.currentSrc || img.src).replace(/([?&])width=\d+/, '$1width=160');
        small.alt = '';
        small.loading = 'lazy';
        button.appendChild(small);
        button.addEventListener('click', function () { goTo(i); });
        thumbs.appendChild(button);
      });
    }
    function showVariantMedia(mediaId) {
      if (!track) return;
      var changed = false;
      Array.prototype.forEach.call(track.querySelectorAll('[data-variant-media]'), function (slide) {
        var hide = mediaId ? String(slide.dataset.mediaId) !== String(mediaId) : slide.hidden;
        if (slide.hidden !== hide) { slide.hidden = hide; changed = true; }
      });
      if (changed) {
        buildThumbs();
        var list = slides();
        var target = 0;
        list.forEach(function (slide, i) { if (String(slide.dataset.mediaId) === String(mediaId)) target = i; });
        goTo(target, true);
      }
      refreshNav();
    }
    if (track) {
      var scrollTimer = null;
      track.addEventListener('scroll', function () { clearTimeout(scrollTimer); scrollTimer = setTimeout(refreshNav, 80); }, { passive: true });
      if (prev) prev.addEventListener('click', function () { goTo(slideIndex() - 1); });
      if (next) next.addEventListener('click', function () { goTo(slideIndex() + 1); });
      track.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') { event.preventDefault(); goTo(slideIndex() + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(slideIndex() - 1); }
      });
      buildThumbs();
      refreshNav();
    }

    /* ——— Options, prix, variante ——— */
    function setMessage(text, withCartLink) {
      if (!message) return;
      message.textContent = '';
      if (!text) { message.hidden = true; return; }
      message.appendChild(document.createTextNode(text));
      if (withCartLink) {
        var link = document.createElement('a');
        link.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
        link.textContent = 'Voir le panier';
        message.appendChild(document.createTextNode(' '));
        message.appendChild(link);
      }
      message.hidden = false;
    }
    function setCta(state) {
      var label = cta.dataset['label' + state] || cta.dataset.labelAdd;
      ctaLabel.textContent = label;
      var blocked = state === 'Size' || state === 'Soldout';
      cta.setAttribute('aria-disabled', blocked ? 'true' : 'false');
      if (barLabel) barLabel.textContent = state === 'Size' ? cta.dataset.labelSize : (state === 'Soldout' ? cta.dataset.labelSoldout : cta.dataset.labelAdd);
      if (barCta) barCta.setAttribute('aria-disabled', state === 'Soldout' ? 'true' : 'false');
    }
    function update(pushUrl) {
      var choice = selected();
      var sizeIndex = kindIndex('taille');

      // Une valeur qui n'existe pas avec les autres choix (hors taille) est remplacée par la première qui existe.
      options.forEach(function (fs, i) {
        if (i === sizeIndex || i === 0 || choice[i] === null) return;
        var partial = choice.map(function (value, j) { return j === sizeIndex ? null : value; });
        var exists = variants.some(function (v) { return matches(v, partial); });
        if (!exists) {
          var replacement = null;
          Array.prototype.forEach.call(fs.querySelectorAll('[data-option-input]'), function (input) {
            if (replacement) return;
            var attempt = partial.slice(); attempt[i] = input.value;
            if (variants.some(function (v) { return matches(v, attempt) && v.disponible; })) replacement = input;
          });
          if (replacement) { replacement.checked = true; choice[i] = replacement.value; }
        }
      });
      // Une taille qui n'existe pas pour ce modèle et cette couleur est retirée.
      if (sizeIndex >= 0 && choice[sizeIndex] !== null && !variants.some(function (v) { return matches(v, choice); })) {
        var checkedSize = options[sizeIndex].querySelector('[data-option-input]:checked');
        if (checkedSize) checkedSize.checked = false;
        choice[sizeIndex] = null;
      }

      // Disponibilité de chaque valeur, compte tenu des autres choix.
      options.forEach(function (fs, i) {
        Array.prototype.forEach.call(fs.querySelectorAll('[data-option-input]'), function (input) {
          var attempt = choice.slice(); attempt[i] = input.value;
          if (i !== sizeIndex && sizeIndex >= 0) attempt[sizeIndex] = null;
          // Première option (modèle) : jugée seule, car la couleur est ajustée d'elle-même au changement de modèle.
          if (i === 0) attempt = attempt.map(function (value, j) { return j === 0 ? value : null; });
          var available = variants.some(function (v) { return matches(v, attempt) && v.disponible; });
          input.classList.toggle('is-unavailable', !available);
          var label = root.querySelector('label[for="' + input.id + '"]');
          // Une valeur qui n'existe pas du tout pour le modèle choisi (première option) est masquée, pas barrée.
          var exists = i === 0 || choice[0] === null || variants.some(function (v) { return v.options[0] === choice[0] && v.options[i] === input.value; });
          input.hidden = !exists;
          if (label) { label.hidden = !exists; label.title = available ? '' : 'Indisponible avec ce choix'; }
        });
        var valueEl = fs.querySelector('[data-option-value]');
        if (valueEl) valueEl.textContent = choice[i] || '';
      });

      var complete = choice.every(function (value) { return value !== null; });
      current = complete ? (variants.filter(function (v) { return matches(v, choice); })[0] || null) : null;
      var reference = current || variants.filter(function (v) { return matches(v, choice); })[0] || null;

      if (priceEl) {
        var sameChoice = variants.filter(function (v) { return matches(v, choice); });
        var prices = sameChoice.map(function (v) { return v.prix; }).filter(function (p, i, all) { return all.indexOf(p) === i; });
        if (current) { priceEl.textContent = current.prix; if (priceFrom) priceFrom.hidden = true; }
        else if (prices.length === 1) { priceEl.textContent = prices[0]; if (priceFrom) priceFrom.hidden = true; }
        else { priceEl.textContent = data.prixMin; if (priceFrom) priceFrom.hidden = !data.prixVarie; }
        if (barPrice) barPrice.textContent = priceEl.textContent;
      }
      if (current && idInput) idInput.value = current.id;
      if (!complete) setCta('Size');
      else if (!current || !current.disponible) setCta('Soldout');
      else setCta('Add');

      if (reference && reference.media) showVariantMedia(reference.media);

      // Guide des tailles : seul le tableau du modèle choisi reste affiché.
      var guideTables = root.querySelectorAll('[data-guide]');
      if (guideTables.length && choice[0]) {
        var shown = 0;
        Array.prototype.forEach.call(guideTables, function (table) { var keep = table.dataset.guide === choice[0]; table.hidden = !keep; if (keep) shown++; });
        var wrap = root.querySelector('[data-guide-wrap]');
        if (wrap) wrap.hidden = shown === 0;
      }

      if (pushUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        if (current) url.searchParams.set('variant', current.id); else url.searchParams.delete('variant');
        window.history.replaceState({}, '', url.toString());
      }
    }
    options.forEach(function (fs) {
      fs.addEventListener('change', function () { setMessage(''); update(true); });
    });

    /* ——— Quantité ——— */
    function clampQty(value) { var n = parseInt(value, 10); if (!isFinite(n) || n < 1) n = 1; if (n > 10) n = 10; return n; }
    var minus = root.querySelector('[data-qty-minus]');
    var plus = root.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () { qty.value = clampQty(clampQty(qty.value) - 1); });
    if (plus) plus.addEventListener('click', function () { qty.value = clampQty(clampQty(qty.value) + 1); });
    if (qty) qty.addEventListener('change', function () { qty.value = clampQty(qty.value); });

    /* ——— Ajout au panier ——— */
    function askSize() {
      var sizeIndex = kindIndex('taille');
      var target = sizeIndex >= 0 ? options[sizeIndex] : options[0];
      setMessage('Choisissez votre taille pour continuer.');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var first = target.querySelector('[data-option-input]:not(.is-unavailable)');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 350);
      }
    }
    /* ——— Champs client (mission 2026-10-09-01) : prénom, nom, année… en propriétés de ligne. Aucun champ : rien ne change. ——— */
    var persoFields = Array.prototype.slice.call(root.querySelectorAll('[data-perso-champ]'));
    var persoOk = /^[A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF\u0152\u0153\u01780-9 '\u2019\-,.&\u00B7]+$/;
    var persoOkDate = /^[A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF\u0152\u0153\u01780-9 '\u2019\-,.&\u00B7\/]+$/;
    function persoValue(field) { return String(field.value || '').normalize('NFC').replace(/\s+/g, ' ').trim(); }
    /* Téléphone au verso (mission 2026-10-09-04, médaille gravée) : 10 chiffres français (0X…), ou +33 / 0033 puis 9 chiffres (remis en
       0X XX XX XX XX), ou +32 / 0032 puis 8 ou 9 chiffres (Belgique, gardé en +32). Rend la forme gravée, ou null si le numéro est refusé. */
    function persoPhone(raw) {
      var d = String(raw || '').replace(/[\s.\-()\u00A0]/g, '');
      var m;
      if ((m = /^(?:\+33|0033)([1-9]\d{8})$/.exec(d))) d = '0' + m[1];
      if (/^0[1-9]\d{8}$/.test(d)) return d.replace(/(\d{2})(?=\d)/g, '$1 ').trim();
      if ((m = /^(?:\+32|0032)(\d{8,9})$/.exec(d))) {
        var n = m[1], head = n.length === 9 ? 3 : 2;
        return '+32 ' + n.slice(0, head) + ' ' + n.slice(head).replace(/(\d{2})(?=\d)/g, '$1 ').trim();
      }
      return null;
    }
    persoFields.forEach(function (field) {
      var counter = field.closest('.cdc-motif__champ') && field.closest('.cdc-motif__champ').querySelector('[data-perso-compte]');
      var refresh = function () {
        if (counter) counter.textContent = field.dataset.persoType === 'telephone' ? (persoPhone(field.value) || '') : Array.from(persoValue(field)).length + ' sur ' + field.dataset.persoMax + ' caractères';
        field.removeAttribute('aria-invalid');
      };
      field.addEventListener('input', refresh); field.addEventListener('change', refresh); refresh();
    });
    function persoCheck() {
      var properties = {};
      for (var i = 0; i < persoFields.length; i++) {
        var field = persoFields[i], value = persoValue(field), max = parseInt(field.dataset.persoMax || '0', 10), problem = '';
        if (!value) problem = field.tagName === 'SELECT' ? 'Choisissez « ' + field.dataset.persoCle + ' » pour continuer.' : 'Indiquez « ' + field.dataset.persoCle + ' » pour continuer.';
        else if (field.dataset.persoType === 'telephone') {
          var phone = persoPhone(value);
          if (phone) value = phone;
          else problem = '« ' + field.dataset.persoCle + ' » : indiquez un numéro à 10 chiffres (ex. 06 12 34 56 78), ou +33 / +32 suivi du numéro.';
        }
        else if (field.tagName !== 'SELECT' && max && Array.from(value).length > max) problem = '« ' + field.dataset.persoCle + ' » : ' + max + ' caractères au plus.';
        /* Champ « date » (mission 2026-11-02-18, prénom et date du tatouage) : la barre oblique est aussi permise (ex. « Sarah 02/11 »). */
        else if (field.tagName !== 'SELECT' && !(field.hasAttribute('data-perso-date') ? persoOkDate : persoOk).test(value)) problem = '« ' + field.dataset.persoCle + ' » : lettres, chiffres, espaces, apostrophes, tirets et virgules seulement (pas d’émoji ni de symbole).';
        if (problem) {
          field.setAttribute('aria-invalid', 'true');
          setMessage(problem);
          field.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(function () { field.focus({ preventScroll: true }); }, 350);
          return null;
        }
        properties[field.dataset.persoCle] = value;
      }
      return properties;
    }

    function addToCart() {
      if (busy) return;
      if (!current) { askSize(); return; }
      var persoProps = persoFields.length ? persoCheck() : {};
      if (persoProps === null) return;
      if (!current.disponible) { setMessage('Ce choix est indisponible pour le moment. Essayez une autre taille ou une autre couleur.'); return; }
      busy = true;
      setMessage('');
      ctaLabel.textContent = cta.dataset.labelAdding;
      var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root_url + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [Object.assign({ id: current.id, quantity: clampQty(qty ? qty.value : 1) }, persoFields.length ? { properties: persoProps } : {})] })
      }).then(function (response) {
        return response.json().then(function (body) { if (!response.ok) throw new Error(body && (body.description || body.message) || 'Ajout impossible'); return body; });
      }).then(function () {
        // Sac cadeau réutilisable (mission 2026-10-06-13) : la case cochée ajoute un sac après l'article, jamais un deuxième.
        var bagBox = form && form.querySelector('[data-cdc-sac-produit-case]');
        if (bagBox && bagBox.checked && window.CDCGiftBag && typeof window.CDCGiftBag.addOne === 'function') {
          bagBox.checked = false;
          return window.CDCGiftBag.addOne().catch(function () { return false; });
        }
      }).then(function () {
        return fetch(root_url + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      }).then(function (cart) {
        ctaLabel.textContent = cta.dataset.labelAdded;
        setTimeout(function () { busy = false; update(false); }, 1600);
        var themeCart = window.theme && window.theme.Cart;
        if (themeCart && typeof themeCart.setCurrentData === 'function' && typeof themeCart.showPopup === 'function') {
          try {
            themeCart.setCurrentData(cart);
            Promise.resolve(typeof themeCart.updateCart === 'function' ? themeCart.updateCart() : null).then(function () { themeCart.showPopup(); });
            return;
          } catch (error) { /* repli ci-dessous */ }
        }
        setMessage('Ajouté au panier.', true);
      }).catch(function (error) {
        busy = false;
        update(false);
        setMessage(error && error.message && error.message !== 'Ajout impossible' ? error.message : 'L’ajout au panier n’a pas abouti. Réessayez dans un instant.');
      });
    }
    if (form) form.addEventListener('submit', function (event) { event.preventDefault(); addToCart(); });
    if (barCta) barCta.addEventListener('click', function () { addToCart(); });

    /* ——— Barre mobile : visible quand le bouton principal sort de l'écran ——— */
    if (bar && cta && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        bar.hidden = entries[0].isIntersecting;
      }, { threshold: 0 });
      observer.observe(cta);
    }

    update(false);
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-cdc-motif]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
